<template>
  <div class="view-505">
    <img
      class="x32_2_-certificate_2_"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/-x32-2--certificate-2-@2x.png"
      alt="x32_2._Certificate_2_"
    />
    <img
      class="line-46"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/line-46.svg"
      alt="Line 46"
    />
    <x382 :x1="x3821Props.x1" />
    <div class="x2-27">
      <div class="ellipse-170"></div>
      <div class="x1-78 poppins-normal-white-40px">10</div>
      <img
        class="line-46-1"
        src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/line-46.svg"
        alt="Line 46"
      />
    </div>
    <x382 :x1="x3822Props.x1" :className="x3822Props.className" />
    <x382 :x1="x3823Props.x1" :className="x3823Props.className" />
    <x382 :x1="x3824Props.x1" :className="x3824Props.className" />
    <x392 :x1="x3921Props.x1" />
    <x392 :x1="x3922Props.x1" :className="x3922Props.className" />
    <x392 :x1="x3923Props.x1" :className="x3923Props.className" />
    <x392 :x1="x3924Props.x1" :className="x3924Props.className" />
    <div class="x1-79">
      <div class="ellipse-170-1"></div>
      <div class="number-22 poppins-normal-white-40px-2">1</div>
    </div>
  </div>
</template>

<script>
import X382 from "./X382";
import X392 from "./X392";
export default {
  name: "View48",
  components: {
    X382,
    X392,
  },
  props: [
    "x3821Props",
    "x3822Props",
    "x3823Props",
    "x3824Props",
    "x3921Props",
    "x3922Props",
    "x3923Props",
    "x3924Props",
  ],
};
</script>

<style>
.view-505,
.view-506 {
  height: 75px;
  left: 93px;
  position: absolute;
  top: 727px;
  width: 1182px;
}

.x32_2_-certificate_2_,
.x32_2_-certificate_2_-1 {
  height: 75px;
  left: 1102px;
  position: absolute;
  top: 0;
  width: 80px;
}

.line-46,
.line-46-2 {
  height: 1px;
  left: 1050px;
  object-fit: cover;
  position: absolute;
  top: 29px;
  width: 50px;
}

.x2-27,
.x2-28 {
  height: 60px;
  left: 940px;
  position: absolute;
  top: 1px;
  width: 112px;
}

.ellipse-170,
.ellipse-170-2 {
  aspect-ratio: 1;
  background-color: var(--black-7);
  border: 1px solid;
  border-color: var(--black-8);
  border-radius: 30px;
  height: 60px;
  left: 50px;
  position: absolute;
  top: 0;
  width: 60px;
}

.x1-78,
.x1-80 {
  left: 60px;
  letter-spacing: 0.8px;
  line-height: normal;
  position: absolute;
  top: 0;
}

.line-46-1,
.line-46-3 {
  height: 1px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 29px;
  width: 50px;
}

.x1-79,
.x1-81 {
  height: 60px;
  left: 0;
  position: absolute;
  top: 1px;
  width: 62px;
}

.ellipse-170-1,
.ellipse-170-3 {
  aspect-ratio: 1;
  background-color: var(--shiraz);
  border-radius: 30px;
  height: 60px;
  left: 0;
  position: absolute;
  top: 0;
  width: 60px;
}

.number-22,
.number-23 {
  left: 24px;
  letter-spacing: 0.8px;
  line-height: normal;
  position: absolute;
  top: 0;
}
</style>
